import { Component, Input, OnInit } from '@angular/core';
import { CheckoutService } from '../../../services/checkout/checkout.service';
import { environment } from 'src/environments/environment';
import { IdentialertSubSelectionModalComponent } from '../subscription-pages/identialert-sub-selection-modal/identialert-sub-selection-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductType, User } from 'src/app/interfaces/user';

@Component({
  selector: 'app-main-plan-card',
  templateUrl: './main-plan-card.component.html',
  styleUrls: ['./main-plan-card.component.scss'],
})
export class MainPlanCardComponent implements OnInit {
  @Input()
  public content;
  @Input()
  public petName;
  @Input()
  public petType;
  @Input()
  public thereIsOnlyOneCat: boolean;
  @Input()
  public isOutdoors: boolean;
  @Input()
  public hideIcon: boolean;
  @Input () 
  public disabledBuyNow: boolean;
  @Input() userCurrentProductType: number;

  public subtitleText: string;
  public backgroundImage: string;
  public isUpgrade: boolean;
  
  constructor(private checkoutService: CheckoutService, private _modalService: NgbModal) {}

  ngOnInit(): void {
    this.subtitleText = this.petName ? `${this.petName}’s lifeline, anytime. Stay prepared and reunite with your pet faster.` :
     'Your pet’s lifeline, anytime. <br> Stay prepared and reunite with your pet faster.'
    if (this.thereIsOnlyOneCat) {
      if (this.isOutdoors) {
        this.subtitleText = `For the intrepid adventurer as well as those who simply enjoy a stroll in the garden, cats who venture outdoors are at risk of being lost or stolen. Bring ${this.petName} home with identialert.` 
      } else {
        this.subtitleText = `Indoor-only cats are uniquely at risk of getting lost or being stolen. Bring ${this.petName} home with identialert.`;
      }
    }
    if (this.petType === 1) {
      this.backgroundImage = 'url(/assets/images/main-plan-card/dogBanner.jpeg';
    } else if (this.petType === 2 && this.thereIsOnlyOneCat && this.isOutdoors) {
      this.backgroundImage = 'url(/assets/images/main-plan-card/outdoorcatBanner.jpeg)';
    } else if (this.petType === 2 && this.thereIsOnlyOneCat) {
      this.backgroundImage = 'url(/assets/images/main-plan-card/indoorCatBanner.jpeg)';
    } else {
      this.backgroundImage = 'url(/assets/images/main-plan-card/catBanner.jpeg)';
    }

    this.isUpgrade = this.userCurrentProductType === ProductType.Basic;
  }

  public buyIdentialertSubs() {
    this.checkoutService
    .checkout(
      [environment.stripePlans.identiAlertAnnual],
      { isUpgrade: this.isUpgrade }
    ).subscribe(
      () => {
        // Nothing should happen here because if checkout gets completed successfully, a redirect
        // will be triggered by stripe checkout
      },
      (err) => {}
    );
  }

  public buyIdentiAlertSubscription() {
    const identialertSubSelectionModalRef = this._modalService.open(
      IdentialertSubSelectionModalComponent,
      {
        backdrop: 'static',
        centered: true,
        size: 'md',
      }
    );
    identialertSubSelectionModalRef.componentInstance.modalRef = identialertSubSelectionModalRef;
    identialertSubSelectionModalRef.componentInstance.isUpgrade = this.isUpgrade;
  }
}
